// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__8Q35M","solid":"divider_solid__KCF63","dotted":"divider_dotted__ic5Cn","dashed":"divider_dashed__39ymc"};